<div class="section" id="home">
  <div class="container">
    <Heading />

    <div class="columns">
      <div class="column is-three-fifths-desktop is-offset-one-fifth-desktop">
        <h2 class="is-size-5 mb-3 has-text-centered">
          Starte jetzt in deine Golf-Karriere
        </h2>
        <Videoplayer videoUrl="{videoUrl}" />
      </div>
    </div>

    <div class="columns">
      <div class="column is-one-fifth"></div>
      <div class="column is-two-fifth-fifth">
        Jetzt zum theoretischen Teil deiner Platzreifeprüfung gehen.
      </div>
      <div class="column is-two-fifth-fifth has-text-right">
        <button
          class="button is-outlined"
          on:click="{nextPage}"
        >Dashboard</button>
      </div>
      <div class="column is-one-fifth"></div>
    </div>
  </div>
</div>

<script>
import { onMount } from "svelte";

import { push } from "svelte-spa-router";
import Heading from "./Heading.svelte";
import { club } from "./stores";
import Videoplayer from "./Videoplayer.svelte";
const videoUrl = "https://player.vimeo.com/video/500936341"; // Intro Video

let clubData;

onMount(() => {
  club.subscribe((data) => (clubData = data));
});

const nextPage = () => {
  if (clubData?.manager?.video && clubData?.manager?.video_anzeigen) {
    push("/manager");
    return;
  }
  push("/platzreife");
};
</script>

<style type="text/scss">
// @import "./scss/video-iframe";
.is-max-width-90 {
  max-width: 90%;
}
.tile-image-button {
  cursor: pointer;
  height: 60vh;
  background-size: cover;
  background-position: center center;
  .title {
    color: #fff;
    text-shadow: 1px 1px 2px #000;
  }
}
</style>
